import { render, staticRenderFns } from "./popup-bind-cheng-yuan.vue?vue&type=template&id=35ad3a35&scoped=true"
import script from "./popup-bind-cheng-yuan.vue?vue&type=script&lang=js"
export * from "./popup-bind-cheng-yuan.vue?vue&type=script&lang=js"
import style0 from "./popup-bind-cheng-yuan.vue?vue&type=style&index=0&id=35ad3a35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad3a35",
  null
  
)

export default component.exports